import styled, { css, ThemeProps, DefaultTheme } from 'styled-components';
import { memoizeFunction } from '@agilepoint/utils-common';
import { isVertical, selectTabsPanelTheme, TabStyleFuncMap, createTabStyleFragmentSelector } from '../utils';
import { TabOrientation, TabStyle } from '../tab-types';

const getWidth = memoizeFunction((tabOrientation: TabOrientation) => ((isVertical(tabOrientation)) ? '150px' : 'unset'));

const getDisplayPropValue = memoizeFunction((tabOrientation: TabOrientation) => ((isVertical(tabOrientation)) ? 'inline-block' : 'inline-flex'));

interface ITabHeaderWrapperProps {
    tabStyle: TabStyle;
    tabOrientation: TabOrientation;
    tabOverflow: boolean;
}

type TabHeaderItemsContainerStylesByType = TabStyleFuncMap<ITabHeaderWrapperProps & ThemeProps<DefaultTheme>>;

const lineStyles: TabHeaderItemsContainerStylesByType = {
    base: memoizeFunction((t, { tabOrientation }) => css`
        border-style: solid;
        ${isVertical(tabOrientation) ?
            css`border-radius: ${t.composites.borderRadius.header} 0 0 ${t.composites.borderRadius.header};` :
            css`border-radius: ${t.composites.borderRadius.header} ${t.composites.borderRadius.header} 0 0;`}
    `)
};

const conventionalStyles: TabHeaderItemsContainerStylesByType = {
    base: memoizeFunction(() => css`
        border-style: none;
    `)
};

const selectStyle = createTabStyleFragmentSelector<ITabHeaderWrapperProps & ThemeProps<DefaultTheme>>({
    line: lineStyles,
    conventional: conventionalStyles
});

export const TabHeaderItemsContainer = styled.div.attrs(() => ({
    className: String('ap-tabsPanel-tabHeaderItemsContainer')
})) <ITabHeaderWrapperProps>`
    overflow: hidden;
    white-space: nowrap;
    position: relative;
    box-sizing: border-box;
    border-color: ${selectTabsPanelTheme(t => t.colors.tabHeaderWrapperBorder)};
    border-width: ${selectTabsPanelTheme(t => t.composites.border.header)};
    display: ${({ tabOrientation }) => getDisplayPropValue(tabOrientation)};
    width: ${({ tabOrientation }) => getWidth(tabOrientation)};
   ${({ tabOrientation }) => isVertical(tabOrientation) && css`vertical-align: top;`};
    
    ${selectStyle('base')}
    
    top: 0;
    left: 0;
`;
